module.exports = __webpack_public_path__ + "img/5.ec6df59f.svg";